import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Constants from '../../config/constants';
import Layout from '../../components/layout/Layout';
import { InfoCard } from '../../components/card/InfoCard';
import ZoneComponent from '../../components/zone/ZoneComponent';
import ZoneEditModal from '../../modal/zone/ZoneEditModal';
import Card from '../../components/card/Card';
import Alert from '../../modal/alert/Alert';

import { FORMATTER_STYLE, getFormatter } from '../../utils/formatter';
import { defaultRejectHandler, getErrorValue } from '../../utils/utility';

import {
  clearErrorZone,
  deleteZone,
  getZone,
} from '../../redux/zone/zone_actions';

class ZoneDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    this.state = {
      categoryOption: 'all',
      isShowCreateModal: false,
      isShowEditModal: false,
      isShowDeleteModal: false,
    };
  }

  renderActionMenu() {
    const { t } = this.props;
    return [
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#edit-zone"
          onClick={() => this.setState({ isShowEditModal: true })}
        >
          <i className="fas fa-edit" />
          <span className="menu-text">{t('edit zone')}</span>
        </a>
      </li>,
      <li>
        <a
          href="#"
          data-toggle="modal"
          data-target="#delete-zone"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" />
          <span className="menu-text">{t('delete zone')}</span>
        </a>
      </li>,
    ];
  }

  componentDidMount() {
    this.props.getZone(this.props.match.params.zoneId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isEditing && nextProps.isEditing !== this.props.isEditing && !nextProps.errorMessage) {
      this.dismissEditModal();
    }

    if (this.props.isDeleting && nextProps.isDeleting !== this.props.isDeleting && !nextProps.errorMessage) {
      this.props.history.push(`/projects/${this.props.zoneDetail.project_id}`);
    }
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  renderZoneDetail(zone) {
    const { isShowEditModal, isShowDeleteModal } = this.state;
    const { isDeleting, errorMessage, t } = this.props;

    const fields = [
      {
        id: 'floor-name',
        label: t('floors'),
        value: zone.floor_name || t('unassigned'),
      },
      {
        id: 'project-name',
        label: t('project name'),
        value: zone.building_name || t('unassigned'),
      },
      {
        id: 'zone-area',
        label: t('area'),
        value: `${zone.area === null ? '-' : getFormatter(FORMATTER_STYLE.floatFractionDigit2)(zone.area)} ${t('sq m')}`
      },
      {
        id: 'zone-description',
        label: t('description'),
        value: zone.description || '-',
      },
    ];
    return (
      <div>
        <ZoneEditModal
          zone={zone}
          show={isShowEditModal}
          onHide={() => this.dismissEditModal()}
          building={{ id: zone.building_id }}
        />
        <Alert
          show={isShowDeleteModal}
          onHide={() => !isDeleting && this.dismissDeleteModal()}
          title={t('delete zone')}
          body={`${t('do you want to delete')} ${zone ? zone.name : ''}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={isDeleting ? t('deleting') : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!isDeleting}
          onPrimaryButtonClick={() => this.props.deleteZone(zone)}
        />
        <h1>{zone.name}</h1>
        <InfoCard fields={fields} />
      </div>
    );
  }

  renderZoneComponents(zone) {
    return (
      <Card padding={false}>
        <ZoneComponent zone={zone} />
      </Card>
    );
  }

  getBreadcrumb(zone) {
    if (zone.is_project_mixed_use) {
      return [
        {
          name: zone.building_name,
          path: `/buildings/${zone.building_id}`,
        },
        {
          name: zone.name,
          path: `/zones/${zone.id}`,
        },
      ];
    } else {
      return [
        {
          name: zone.project_name,
          path: `/projects/${zone.project_id}`,
        },
        {
          name: zone.name,
          path: `/zones/${zone.id}`,
        },
      ];
    }
  }

  render() {
    const { zoneDetail: zone } = this.props;
    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={zone ? this.getBreadcrumb(zone) : []}
        renderActionMenu={() => this.renderActionMenu()}
      >
        {zone && this.renderZoneDetail(zone)}
        {zone && this.renderZoneComponents(zone)}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  zoneDetail: state.zone.objects[ownProps.match.params.zoneId],
  isEditing: state.zone.isEditing,
  isDeleting: state.zone.isDeleting,
  errorMessage: state.zone.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  getZone: id => defaultRejectHandler(dispatch(getZone(id))),
  deleteZone: ({ id }) => defaultRejectHandler(dispatch(deleteZone(id))),
  clearError: () => dispatch(clearErrorZone()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ZoneDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/zone/ZoneDetailPage.js